// Slovak (sk-SK) formatters. Use non-breaking thousands separator.

const moneyFmt = new Intl.NumberFormat("sk-SK", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const qtyFmt = new Intl.NumberFormat("sk-SK", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

export function formatMoney(n: number, currency = "EUR"): string {
  const symbol = currency === "EUR" ? "€" : currency;
  return `${moneyFmt.format(n)} ${symbol}`;
}

export function formatMoneyPlain(n: number): string {
  return moneyFmt.format(n);
}

export function formatQty(n: number): string {
  return qtyFmt.format(n);
}

export function formatDateSk(iso: string): string {
  // Display SK style: "15. 4. 2026"
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const [y, m, d] = iso.split("-");
  return `${Number(d)}. ${Number(m)}. ${y}`;
}
